<template>
  <div class="card">
    <div class="head">
      <h3>概述</h3>
    </div>
    <div>
      <a-progress
        type="circle"
        :percent="percent"
        :width="110"
        :strokeWidth="10"
        strokeColor="#1564FF"
        stroke-linecap="square"
      >
        <template #format="percent">
          <p style="color: #181D21;font-size: 22px; font-weight: bold;text-align: center;">{{ percent }}%</p>
          <p style="color: #181D21;text-align: center;">正确率</p>
        </template>
      </a-progress>
      <div class="infos">
        <p class="info_item">
          <span class="txt">排名</span>
          <span>：{{ rankData.rank }}</span>
        </p>
        <p class="info_item">
          <span class="txt">正确数</span>
          <span>：{{ rankData.rightNum }}</span>
        </p>
        <p class="info_item">
          <span class="txt">答题人数</span>
          <span>：{{ data.joinNum }}</span>
        </p>
        <p class="info_item">
          <span class="txt">错误数</span>
          <span>：{{ rankData.quesNum - rankData.rightNum }}</span>
        </p>
        <p class="info_item">
          <span class="txt">班级人数</span>
          <span>：{{ data.stuNum }}</span>
        </p>
        <p class="info_item">
          <span class="txt">总题数</span>
          <span>：{{ data.quesNum }}</span>
        </p>
        <p class="info_item">
          <span class="txt">答题耗时</span>
          <span>：{{ formatSecToString(rankData.useTime) }}</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          rightPercent: 0,
          list: [],
          useTime: 0
        }
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    percent() {
      if (this.data.rightPercent) {
        return parseFloat(this.data.rightPercent)
      } else {
        return 0
      }
    },
    rankData() {
      if (this.data.list && this.data.list.length) {
        return this.data.list.find(item => item.me)
      } else {
        return {}
      }
    }
  },
  methods: {
    formatSecToString(second) {
      const res = []
      res.push(String(Math.floor(second / 3600)).padStart(2, 0)) // add H
      second %= 3600
      res.push(String(Math.floor(second / 60)).padStart(2, 0)) // add M
      second %= 60
      res.push(String(Math.floor(second % 60)).padStart(2, 0)) // add S
      return `${res[0]}小时${res[1]}分钟${res[2]}秒`
    }
  }
}
</script>
<style lang="less" scoped>
@import './index.less';
.ant-progress {
  margin-left: 50%;
  margin-top: 24px;
  transform: translateX(-55px);
}
.infos {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 12px;
  .info_item {
    margin-top: 18px;
    min-width: 50%;
    .txt {
      display: inline-block;
      width: 60px;
      text-align-last: justify;
    }
  }
}
.tr {
  text-align: right;
}
</style>
